import { render, staticRenderFns } from "./__PasswordVault.vue?vue&type=template&id=07a71b06"
import script from "./__PasswordVault.vue?vue&type=script&lang=js"
export * from "./__PasswordVault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports